import Vue from 'vue'
import Router from 'vue-router'
import { isAfter } from "date-fns";
import Login from './components/Login';
import Logout from './components/Logout';
import PlanningDashboard from "./components/dashboards/PlanningDashboard";
import NetworkUsageDashboard from './components/dashboards/NetworkUsageDashboard';
import store from './store';
import SessionExpired from './components/errors/SessionExpired';
import AccessDeniedError from "./components/errors/AccessDeniedError";
import SchoolsSelector from "./components/SchoolsSelector";
import InternetUsageDashboard from './components/dashboards/InternetUsageDashboard';
import RoadmapDashboard from './components/dashboards/RoadmapDashboard';
import FAQDashboard from './components/dashboards/FAQDashboard';
import LandingDashboard from "./components/dashboards/LandingDashboard";

Vue.use(Router);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: LandingDashboard,
    meta: {
      title: 'Home',
      requiresAuth: true,
      navigation: true,
    }
  },
  {
    path: '/managed-devices',
    name: 'ManagedDevices',
    component: PlanningDashboard,
    meta: {
      title: 'Managed Devices',
      requiresAuth: true,
      navigation: true,
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      title: 'Login',
      requiresAuth: false,
      navigation: false,
    }
  },
  {
    path: '/logout',
    name: 'Logout',
    component: Logout,
    meta: {
      title: 'Logout',
      requiresAuth: false,
      navigation: false,
    }
  },
  {
    path: '/token/:token',
    name: 'SetToken',
    component: Login,
    beforeEnter: (to, from, next) => {
      const token = to.params.token;
      if (!token) {
        next('/login');
      } else {
        store.commit('SET_TOKEN', token);
        next('/');
      }
    },
    meta: {
      requiresAuth: false,
      navigation: false,
    }
  },
  {
    path: '/auth/expired',
    name: 'SessionExpired',
    component: SessionExpired,
    meta: {
      requiresAuth: false,
      navigation: true,
    }
  },
  {
    path: '/auth/failure',
    name: 'AuthenticationFailure',
    component: AccessDeniedError,
    meta: {
      requiresAuth: false,
      navigation: false,
    }
  },
  {
    path: '/internet-usage',
    name: 'InternetUsage',
    component: InternetUsageDashboard,
    meta: {
      title: 'Internet Usage',
      requiresAuth: true,
      navigation: true
    },
  },
  {
    path: '/network-usage',
    name: 'NetworkUsage',
    component: NetworkUsageDashboard,
    meta: {
      title: 'Network Usage',
      requiresAuth: true,
      navigation: true
    },
  },
  {
    path: '/roadmap',
    name: 'Roadmap',
    component: RoadmapDashboard,
    meta: {
      title: 'Roadmap',
      requiresAuth: true,
      navigation: true
    },
  },
  {
    path: '/help-and-support',
    name: 'HelpAndSupport',
    component: FAQDashboard,
    meta: {
      title: 'Help & Support',
      requiresAuth: true,
      navigation: true
    },
  },
  {
    path: '/schools/select',
    name: 'SchoolsSelector',
    component: SchoolsSelector,
    meta: {
      requiresAuth: true,
      navigation: true
    },
  },
  {
    path: '*',
    redirect: '/'
  }
];

const router = new Router({routes});

router.beforeEach(async (to, from, next) => {
  document.title = to.meta.title || 'ICTPlus';
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      console.debug('logged in');

      const expiryDate = store.getters.tokenExpiryDate;
      if (expiryDate) {
        console.debug('expiryDate = '+ expiryDate.toString());
        const localExpiryDate = new Date(expiryDate.toISOString());
        console.debug('localExpiryDate = '+ localExpiryDate.toString());
        const now = new Date();
        console.debug('now = '+ now.toString());
        if (isAfter(now, localExpiryDate)) {
          console.log('Token has expired');
          return next('/auth/expired');
        }
      }
      next();
      return
    } else {
      console.debug('not logged in');
      window.location = '/auth/saml/redirect';
      return
    }
  } else {
    console.debug('No authentication required for this route.');
    next();
  }
});

export default router;
